// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2KN2E","inner":"Form_inner__IjxvN","range":"Form_range__1qccz","name":"Form_name__IX3dE","actions":"Form_actions__1nX8_"};